import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContaBancaria, Page } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContaBancariaService extends BaseResourceService<ContaBancaria> {

  constructor(
    protected injector: Injector
  ) {
    super(`contas-bancarias`, injector);
  }

  public obterPorNumeroConta(numero: string, agencia?: string, orgaoId?: number): Observable<Page> {
    const whereAgencia = agencia ? `&agencia=${agencia}` : '';
    if (!orgaoId) {
      orgaoId = this.login.orgao.id;
    }
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}?numero_conta$like=${numero}&${whereAgencia}&orgao_id=${orgaoId}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorNome(nome: string, orgaoId: number): Observable<Page> {
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}/filtrar?nome$like=${nome.toUpperCase()}%&orgao.id=${orgaoId}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorFicha(ficha: number, orgaoId: number): Observable<Page> {
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}/filtrar?id=${ficha}&relations=banco&orgao.id=${orgaoId}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterSaldoBancario(exercicioId: number, orgaoId: number, dataReferencia: string): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/saldo-bancario/${exercicioId}/${orgaoId}?data=${dataReferencia}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterSaldoCaixa(exercicioId: number, orgaoId: number, dataReferencia: string): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/saldo-caixa/${exercicioId}/${orgaoId}?data=${dataReferencia}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterSaldoBancarioConta(id: number, exercicioId: number, orgaoId: number, dataReferencia: string): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/saldo-bancario-conta/${id}/${exercicioId}/${orgaoId}?data=${dataReferencia}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public boletimBanco(exercicioId: number, orgaoId: number, dataInicial: string, dataFinal: string): Observable<any> {
    const parametros = `?data_inicial=${dataInicial}&data=${dataFinal}`;
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/boletim-banco/${exercicioId}/${orgaoId}${parametros}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public boletimCaixa(exercicioId: number, orgaoId: number, data: string): Observable<any> {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/boletim-caixa/${exercicioId}/${orgaoId}/${data}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public conciliacaoBancaria(exercicioId: number, orgaoId: number, dataInicial: string, dataFinal: string): Observable<any> {
    const parametros = `?data_inicial=${dataInicial}&data=${dataFinal}`;
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/conciliacao-bancaria/${exercicioId}/${orgaoId}${parametros}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
